import { Component } from '@angular/core';
import { environment } from '../../../../../public/environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'lib-footer',
  standalone: false,
  templateUrl: './footer.component.html'
})
export class FooterComponent {
  originUrl = '';
  currentYear = new Date().getFullYear();

  constructor(
    private router: Router,
  ) {
    if (!location.origin.includes('localhost')) {
      if (location.origin != environment.siteUrl) {
        this.originUrl = environment.siteUrl;
      }
    }
  }

  link(dis: string) {
    if (this.originUrl) {
      window.open(environment.siteUrl + '/' + dis, '_blank');
    } else {
      this.router.navigate([dis]);
    }
  }
}
